import { COLOR_PALETTE } from 'constants/ui';

import { DataDisplayVariant } from './DataDisplay.constants';

export const getDataDisplayStyles = noTruncate => ({
  position: 'relative',
  flexDirection: 'row',
  gap: '16px',
  alignItems: noTruncate ? 'start' : 'center',
  borderRadius: '8px',
  transition: 'background-color 0.2s ease',
  cursor: 'default',
  overflow: 'hidden',
  width: '100%',
});

export const getContentWrapperStyles = ({ isModified, variant }) => ({
  gap: variant === DataDisplayVariant.STYLE_A ? '4px' : '0',
  overflow: 'hidden',
  width: '100%',

  '& .title-panel': {
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
  },

  '& .info-icon': {
    color: ({ palette }) => palette.text.dark,
  },

  '& .text-value': {
    color: ({ palette }) => {
      if (!isModified) {
        return palette.text.primary;
      }

      // ADDITIONAL[2] is a dark amber readable on light; on dark use the brighter amber tint.
      return palette.mode === 'dark' ? COLOR_PALETTE.ADDITIONAL[3] : COLOR_PALETTE.ADDITIONAL[2];
    },
  },
});
